/**
 * @generated SignedSource<<6b3bd98096ad7914d43d8e12c5675583>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BillingSection_organizationBilling$data = {
  readonly annualBilling: boolean;
  readonly awsAccountId: string;
  readonly billingModel: string;
  readonly creditBalance: number;
  readonly creditLimit: number | null | undefined;
  readonly creditLimitPeriod: string;
  readonly currentPeriodEnd: any;
  readonly currentPeriodStart: any;
  readonly effectiveCreditsLimit: number;
  readonly effectivePlanName: string;
  readonly id: any;
  readonly isEnterprise: boolean;
  readonly marketplaceType: string | null | undefined;
  readonly planType: string;
  readonly " $fragmentType": "BillingSection_organizationBilling";
};
export type BillingSection_organizationBilling$key = {
  readonly " $data"?: BillingSection_organizationBilling$data;
  readonly " $fragmentSpreads": FragmentRefs<"BillingSection_organizationBilling">;
};

import BillingSectionRefetchQuery_graphql from './BillingSectionRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": BillingSectionRefetchQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "BillingSection_organizationBilling",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "planType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "marketplaceType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "annualBilling",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "effectivePlanName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEnterprise",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billingModel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "effectiveCreditsLimit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "awsAccountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creditLimit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creditLimitPeriod",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentPeriodStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentPeriodEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creditBalance",
      "storageKey": null
    }
  ],
  "type": "GraphQLOrganizationBilling",
  "abstractKey": null
};

(node as any).hash = "9b6e490d2a3864c028e7e2b5a8d7b07b";

export default node;
